export enum BusEvents {
  GetRentVehicles = "bus:getRentVehicles",
  GetRoutes = "bus:getRoutes",
  Employment = "bus:employment",
  Rent = "bus:rent",
  UnRent = "bus:unRent",
  Process = "bus:process",
  SetCheckpoint = "bus:setCheckpoint",
  StartStop = "bus:startStop",
  SelectRoute = "bus:selectRoute",
}
